import { render } from "./ScrollTop.vue?vue&type=template&id=d01f8712"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=d01f8712&lang=css"
script.render = render

export default script